import React from 'react';
import { Button, ButtonGroup } from '@mui/material';

const CustomTab = (props) => {
    const { data, selected, handleClick, customStyle, icon } = props;
    return (
        <ButtonGroup
            aria-label="small button group"
            variant="outlined"
            sx={{
                background: '#F2F4F7',
                borderRadius: '8px',
                '& .MuiButton-outlined': {
                    borderColor: '#D0D5DD',
                },
                alignItems:'center',
                ...customStyle,
            }}
        >
            {data?.map((item) => (
                <Button
                    onClick={() => handleClick(item)}
                    sx={{
                        color: selected === item ? '#1D2939' : '#344054',
                        background: selected === item ? '#F9FAFB' : '#FFFFFF',
                        fontFamily: 'Inter',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        textTransform: 'none',
                        '&:hover' : {
                            border: 'none',
                        },
                        padding:'8px 12px',
                        borderRadius: selected === item ? '8px' : 'none',
                        alignSelf:'stretch',
                    }}
                    startIcon={selected === item && icon}
                >
                    {item}
                </Button>
            ))}
        </ButtonGroup>
    );
};

CustomTab.defaultProps = {
    icon: null,
    customStyle: {},
};

export default CustomTab;
